module.exports = __webpack_public_path__ + "img/Phone_05.966dce31.jpg";